<template>

    <div class="settings__item data-card block">
        <div class="data-card__head">
            <div class="data-card__title">
                <span class="data-card__label">Логин<sup>*</sup>:</span>
                <span class="data-card__value">{{user.UserName}}</span>
            </div>
            <div class="data-card__link">
                <label style="color:lightgrey" data-toggle="collapse"><span>Изменить</span></label>
                <!--<a href="#dataCard_1" class="link link--present" data-toggle="collapse"><span class="link__text">Изменить</span></a>-->
            </div>
        </div>
        <div id="dataCard_1" class="data-card__form accordion-body collapse">
            <div class="data-card__inner accordion-body__inner">
                <div class="b-form-sm">
                    <div class="b-form-sm__body">
                        <div class="b-form-sm__item">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input"
                                           :class="!$v.newLogin.loginType ? 'is-error' : ''"
                                           type="text"
                                           :placeholder="user.UserName ? user.UserName : 'Новый логин'"
                                           v-model="newLogin">
                                </div>
                            </label>
                        </div>
                        <div class="b-form-sm__item">
                            <a class="button button--th-second"
                               :class="!$v.newLogin.loginType || isEqualUserData ? 'disabled' : ''"
                               v-on:click="changeLogin">Сохранить</a>
                            <a href="#dataCard_1" class="button button--th-link" data-toggle="collapse">Отменить</a>
                        </div>
                    </div>
                </div>

                <div class="txt-input__required txt-input__required--error error-block">{{validateLoginTypeText}}</div>

                <div class="txt-input__required" :class="isValidateErrors ? 'error-block' : 'validated-block'">{{serverResponseText}}</div>

                <div class="data-card__caption validated-block" style="color: #343a4a;">
                    Минимальная длина логина 6 знаков, допускается использование цифр, знаков и букв латинского алфавита
                </div>

            </div>
        </div>
    </div>

</template>

<script>

    const { required } = window.validators
    const { validationMixin, Vuelidate } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['user'],
        data: function () {
            return {
                newLogin: this.user.UserName,
                isValidateErrors: false,
                serverMessage: [],
                serverResponse: '',
            }
        },
        created: function () {
        },
        computed: {
            validateLoginTypeText: function () {
                return !this.$v.newLogin.loginType || this.newLogin == '' ? 'Логин не соответствует установленным требованиям' : ' ';
            },
            serverResponseText: function () {
                return this.serverMessage ? this.serverMessage[0] : '';
            },
            isEqualUserData: function () {
                return this.user.UserName == this.newLogin;
            }
        },
        watch: {
            newLogin: function () {
                if (this.newLogin.length >= 1) {
                    this.serverMessage = [];
                }
            },
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = [];
                }
            },
            serverResponse: function (serverResponse) {
                this.serverMessage = serverResponse.message;

                if (serverResponse.isSuccess) {
                    this.isValidateErrors = false;
                    this.$emit('update', this.newLogin);
                    this.serverMessage = ['Логин успешно изменён, укажите его при следующем входе'];
                } else {
                    this.isValidateErrors = true;
                }
            }
        },
        validations: {
            newLogin: {
                required: required,
                loginType: function (value) {
                    return value.match('^[A-Za-zА-Яа-я0-9!@#$%^&*()_+.]+$') ? true : false;
                }
            }
        },
        methods: {
            changeLogin: function () {
                var self = this;
                this.isValidateErrors = false;

                axios.post('/Profiles/changeLogin', {
                    CurrentUserName: self.user.UserName,
                    NewUserName: self.newLogin.trim()
                })
                    .then(function (response) {
                        self.serverResponse = response.data;
                        document.querySelector('html').classList.remove('is-lock');
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.isValidateErrors = true;
                        self.serverMessage = ['Данный логин уже занят. Попробуйте другой']
                    });
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ChangeLogin.vue